// frontend/app/apiTests.js
import axios from "axios";
import { FASTAPI_BASE_URL } from "./config"; // ← adjust if needed

const U = (p) => `${FASTAPI_BASE_URL}${p}`;

/* ---------- Utilities ---------- */
export function parseEmailsFromText(text) {
  const tokens = String(text || "").replace(/\r/g, "\n").split(/[\s,;]+/);
  const seen = new Set();
  const out = [];
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  for (const tok of tokens) {
    const e = tok.trim().toLowerCase();
    if (e && re.test(e) && !seen.has(e)) {
      seen.add(e);
      out.push(e);
    }
  }
  return out;
}
export function normalizeEmails(emails) {
  return (emails || [])
    .map((e) => String(e || "").trim().toLowerCase())
    .filter(Boolean);
}

/* ---------- Test details ---------- */
export async function getTestDetails(testId) {
  const { data } = await axios.get(U(`/tests/${testId}`));
  return data?.test || {};
}

/* ---------- Shares ---------- */
export async function listTestShares(testId) {
  const { data } = await axios.get(U(`/tests/${testId}/shares`));
  return Array.isArray(data) ? data : [];
}

export async function addTestShares(testId, emails) {
  const payload = { student_emails: normalizeEmails(emails) };
  await axios.post(U(`/tests/${testId}/shares`), payload);
}

export async function removeTestShare(testId, email) {
  await axios.delete(U(`/tests/${testId}/shares`), {
    data: { student_email: String(email || "").trim().toLowerCase() },
  });
}

export async function assignSameDomainToTest(testId) {
  await axios.post(U(`/tests/${testId}/assign_same_domain`));
}

/* ---------- Visibility ---------- */
export async function publishTest(testId, scope = "public") {
  scope = String(scope || "public").toLowerCase();
  await axios.post(U(`/tests/${testId}/publish`), { scope });
}

export async function unpublishTest(testId) {
  await axios.post(U(`/tests/${testId}/unpublish`));
}

// BDD 12/15/2025 - Share tests with class related
// ✅ Share test with a class
export async function shareTestWithClass(testId, classId) {
  console.log("[shareTestWithClass] testId, classId:", testId, classId);
  const { data } = await axios.post(
    `${FASTAPI_BASE_URL}/tests/${testId}/share_with_class`,
    { class_id: classId }
  );
  return data;
}

// ✅ Fetch teacher's classes (use existing backend/classes.py endpoint)
export async function getTeacherClasses(teacherEmail) {
  const response = await axios.get(
    `${FASTAPI_BASE_URL}/classes/teacher/classes`,
    { params: { teacher_email: teacherEmail, for_sharing: true } }
  );
  return response.data?.classes || [];
}

// ✅ List classes that a test is shared with
export async function listSharedClasses(testId, fetchWithAuth) {
  const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shared_classes`);
  if (!res.ok) throw new Error("Failed to list shared classes");
  return await res.json();
}

// ✅ Remove a class from test sharing
export async function removeClassShare(testId, classId, fetchWithAuth) {
  const res = await fetchWithAuth(`${FASTAPI_BASE_URL}/tests/${testId}/shared_classes/${classId}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error("Failed to remove class share");
  return await res.json();
}
